
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whalar/login",
      function () {
        return require("private-next-pages/whalar/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whalar/login"])
      });
    }
  